import { Controller } from "@hotwired/stimulus"

// Updates Alpine's sidebar menu `page` and `subpage` state when turbo frame navigates
// This ensures menu active states stay in sync with the current page
export default class extends Controller {
  // Map URL path prefixes to controller paths for routes that don't follow the standard pattern
  // Keys are the first two URL segments joined by '/', values are the controller_path equivalent
  static pathToControllerMap = {
    'agency/settings': 'agency_settings',
    'agency/enquiries': 'enquiry_settings',
    'agency/viewing-settings': 'viewing_settings',
    'agency/applications': 'application_settings',
    'agency/agreement-templates': 'tenancy_agreement_templates',
    'agency/deposit-schemes': 'agency/deposit_schemes',
    'agency/prescribed-information': 'prescribed_information_settings',
    'agency/accounting': 'bank_account',
    'agency/gas-safety': 'job_settings',
    'agency/eicr': 'eicr_settings',
    'accounting/accounts': 'accounting/accounts',
    'oauth/applications': 'oauth_applications',
    'apps': 'app_installations',
    'rent-reviews': 'rent_reviews',
    'market-intelligence': 'market_intelligence',
  }

  connect() {
    // Listen for turbo frame load events
    this.element.addEventListener("turbo:frame-load", this.updatePage.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.updatePage.bind(this))
  }

  updatePage(event) {
    // Extract the controller name from the URL path
    const url = new URL(event.target.src || window.location.href)
    const path = url.pathname

    // Parse controller name from path (e.g., /properties -> properties, /keys -> keys)
    const pathParts = path.split('/').filter(p => p)
    let controllerName = pathParts[0] || 'dashboard'

    // Check for special path mappings (e.g., /agency/accounting -> bank_account)
    const pathPrefix = pathParts.slice(0, 2).join('/')
    if (this.constructor.pathToControllerMap[pathPrefix]) {
      controllerName = this.constructor.pathToControllerMap[pathPrefix]
    }

    // Extract subpage for routes like /certificates/gas_safety or /certificates/electrical
    // This is used for menu items that share the same controller but have different sub-routes
    const subpage = pathParts[1] || null

    // Update Alpine's sidebarMenu page state
    const sidebarNavs = document.querySelectorAll('[x-data*="sidebarMenu"]')
    sidebarNavs.forEach(sidebarNav => {
      const alpineData = Alpine.$data(sidebarNav)
      if (alpineData && 'page' in alpineData) {
        alpineData.page = controllerName
      }
      // Update subpage for certificate type routes etc.
      if (alpineData && 'subpage' in alpineData) {
        alpineData.subpage = subpage
      }
    })

    // Scroll to top of page on navigation (Turbo Frames don't do this automatically)
    window.scrollTo(0, 0)
  }
}
